import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { RogerLoad } from '../models/RogerLoad';
import { TruckerConfirmationService } from '../services/trucker-confirmation.service';

@Component({
    selector: 'loads-status',
    templateUrl: 'loads-status.component.html',
    styles: [],
    standalone: false
})
export class LoadsStatusComponent implements OnInit, OnChanges {

    constructor(private _truckerConfirmService: TruckerConfirmationService) {

    }

    //@ViewChild('closeButton') closeButton;
    @Input() dispatchId: number = 0;
    @Input() refresh: boolean = false;
    @Input() loadsStatusModalId: string = 'loadsStatusModal';
    @Input() parentComponent: string = 'schedules';
    @Input() showAllRecords: boolean = false;

    errorMessage: string = '';
    loadList: RogerLoad[] = [];
    filteredLoadList: RogerLoad[] = [];
    failedOnly: boolean = false;

    filterLoads() {
        if (this.failedOnly) {
            this.filteredLoadList = this.loadList.filter(item => !item.isSuccess)
        }
        else {
            this.filteredLoadList = this.loadList;
        }
    }

    resetComponent() {
        this.loadList = [];
        this.filteredLoadList = [];
    }

    getLoads(): void {
        if (this.dispatchId > 0) {
            this._truckerConfirmService.getLoadsStatus(this.dispatchId, this.showAllRecords).subscribe({
                next: data => {
                    this.loadList = data;
                    this.filteredLoadList = data;
                },
                error: err => this.errorMessage = err
            });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['dispatchId'] || changes['refresh']) {
            this.resetComponent();
            this.getLoads();

        }
    }

    ngOnInit(): void {
      
       
    }
    
}
